"use client";

import { ModalTabContent } from "../../../../../components/_base/modals/ModalTabContent/ModalTabContent.emotion";
import { SelectLengthContent } from "./SelectLengthContent.emotion";

export const SelectLengthTabContent = () => (
  <ModalTabContent value={"lengthSelectMenu"}>
    <SelectLengthContent />
  </ModalTabContent>
);
